import { MaterialGradeType } from "../types";
import { getMaterialDensity } from "./getMaterialDensity";
import { getMaterialWeight } from "./getMaterialWeight";

type QuoteRequestLineForWeightComputation = {
  assemblyParentId: string | null;
  quantity: number;
  materialGrade: MaterialGradeType | null | undefined;
  part: {
    volume: number | null | undefined;
    weight: number | null | undefined;
    materialGrade: MaterialGradeType | null | undefined;
    quantityInAssembly: number | null;
  } | null;
  layout: {
    materialLayout: {
      density: number | null | undefined;
    } | null;
  } | null;
};

export const computeQuoteRequestWeight = (
  quoteRequestLines: QuoteRequestLineForWeightComputation[],
) => {
  if (quoteRequestLines.length === 0) {
    return 0;
  }

  let totalWeight = quoteRequestLines.reduce((acc, quoteRequestLine) => {
    return acc + computeQuoteRequestLineWeight(quoteRequestLine);
  }, 0);

  return totalWeight;
};

export const computeQuoteRequestLineWeight = (
  quoteRequestLine: QuoteRequestLineForWeightComputation,
) => {
  if (quoteRequestLine.assemblyParentId) {
    return 0;
  }

  const part = quoteRequestLine.part;
  if (!part) {
    return 0;
  }

  const materialLayout = quoteRequestLine.layout?.materialLayout;
  const density =
    materialLayout?.density ||
    getMaterialDensity({
      materialGrade: quoteRequestLine.materialGrade || null,
    });

  const partWeight = part.weight ?? getMaterialWeight(part.volume, density);

  return partWeight * (quoteRequestLine.quantity || 1) * (part.quantityInAssembly || 1);
};
